import React from "react";
import MadeWith from "components/MadeWith";
import Head from "components/Head";
import { isPlatformSubdomain } from "utils/subdomain";
import PATHS from "utils/paths";
import { PageFactoryContextProvider } from "utils/context";
import ErrorNotice from "components/ErrorNotice";
import PageFactoryForm from "components/PageFactoryForm";
import CheckoutInfoNotice from "components/Checkout/InfoNotice";
import { PRODUCT_FEATURE_CAPABILITY } from "utils/constants/capability";
import { getProductFeatureEnabled } from "utils/capability";
import { getPageMetaProps } from "utils/constants/meta";
import Layout from "components/Layout";
import { usePageEditMode } from "utils/hooks";
import { getPageFactoryFormTracking } from "utils/tracking";
import { getSubdomainPageServerSideProps } from "utils/server/page";
import { getConfig } from "utils/env";
import { DATA_ADMIN } from "utils/constants/state";
import get from "lodash/get";

const Pricing = ({
  error,
  manifest,
  content,
  capabilities,
  metadata,
  config,
  // Account is present on page error
  account
}) => {
  const hasEntities = Boolean(
    manifest &&
      manifest.data &&
      manifest.data.entities &&
      manifest.data.entities.length
  );
  const showBranding = !getProductFeatureEnabled(
    capabilities,
    PRODUCT_FEATURE_CAPABILITY.REMOVE_BRANDING
  );
  const { editable } = usePageEditMode();
  const isPlatform = Boolean(config && isPlatformSubdomain(config.subdomain));
  let pageContent;
  let pageContentWrapper;

  if (error) {
    pageContent = (
      <div className="w-100 measure center relative mt5">
        <ErrorNotice error={error} />
      </div>
    );
  } else if (hasEntities) {
    pageContent = (
      <PageFactoryContextProvider admin={get(manifest, DATA_ADMIN)}>
        <PageFactoryForm
          {...manifest}
          tracking={getPageFactoryFormTracking({ manifest, config })}
        />
      </PageFactoryContextProvider>
    );
  } else {
    pageContent = (
      <div className="w-100 measure center relative mt5">
        <CheckoutInfoNotice account={account} content={content} />
      </div>
    );
  }

  if (isPlatform) {
    pageContentWrapper = <Layout>{() => pageContent}</Layout>;
  } else {
    pageContentWrapper = pageContent;
  }

  return (
    <div className="w-100">
      <Head {...getPageMetaProps({ path: PATHS.PRICING, metadata })} />
      {(showBranding || editable) && <MadeWith />}
      {pageContentWrapper}
    </div>
  );
};

/**
 * Any checkout session params are passed along in request to generate client side content
 * - checkout params are then hung off each product action.query
 * - they're then passed along with each checkoutPrice request
 */
export const getServerSideProps = async ({ req }) =>
  await getSubdomainPageServerSideProps({
    req,
    overrides: {
      subdomain: getConfig("APP_SUBDOMAIN"),
      route: PATHS.PRICING,
      alias: null
    }
  });

export default Pricing;
